(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-bedding-ladder-turner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('supplier-bedding-ladder')) {
    class SupplierBeddingLadder extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;
        this.sizeOptionIndex = Number(this.dataset.sizeOptionIndex || 0);
        this.mainVariantId = this.dataset.mainVariant;
        this.mainPrice = Number(this.dataset.mainPrice || 0);
        this.mainSize = this.dataset.mainSize || '';
        this.defaultDepth = this.dataset.defaultDepth || '';
        this.button = this.querySelector('[data-bundle-submit]');
        this.status = this.querySelector('[data-bundle-status]');
        this.changeHandler = (event) => this.handleChange(event);
        this.clickHandler = (event) => this.handleClick(event);
        this.variantHandler = (event) => this.handleMainVariant(event);
        this.addHandler = () => this.addToCart();
        this.addEventListener('change', this.changeHandler);
        this.addEventListener('click', this.clickHandler);
        this.button.addEventListener('click', this.addHandler);
        document.addEventListener('on:variant:change', this.variantHandler);
        this.syncSheetSize(this.mainSize);
        this.syncPillowStyles();
        this.update();
        this.hidden = false;
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.changeHandler);
        this.removeEventListener('click', this.clickHandler);
        this.button?.removeEventListener('click', this.addHandler);
        document.removeEventListener('on:variant:change', this.variantHandler);
      }

      handleChange(event) {
        if (event.target.matches('[data-include-sheet]')) {
          if (!event.target.checked) this.querySelector('[data-include-pillow]').checked = false;
        }
        if (event.target.matches('[data-include-pillow]') && event.target.checked) {
          this.querySelector('[data-include-sheet]').checked = true;
        }
        if (event.target.matches('[data-sheet-depth]')) this.activateDepth(event.target.value, this.getSelectedSheetColour());
        if (event.target.matches('[data-sheet-colour]')) {
          this.updateDepthPrices();
          this.collapsePanel('sheet');
        }
        if (event.target.matches('[data-pillow-colour]')) {
          this.syncPillowStyles();
          this.collapsePanel('pillow');
        }
        this.update();
      }

      handleClick(event) {
        const editButton = event.target.closest('[data-edit-panel]');
        if (editButton) {
          this.expandPanel(editButton.dataset.editPanel);
          return;
        }
        const colourChoice = event.target.closest('[data-collapse-colours]');
        if (colourChoice && !event.target.matches('input')) {
          requestAnimationFrame(() => this.collapsePanel(colourChoice.dataset.collapseColours));
        }
      }

      collapsePanel(panelName) {
        const controls = this.querySelector(`[data-${panelName}-controls]`);
        const editButton = this.querySelector(`[data-edit-panel="${panelName}"]`);
        if (!controls || !editButton || controls.hidden) return;
        controls.hidden = true;
        editButton.hidden = false;
        editButton.setAttribute('aria-expanded', 'false');
        requestAnimationFrame(() => editButton.focus({ preventScroll: true }));
      }

      expandPanel(panelName) {
        const controls = this.querySelector(`[data-${panelName}-controls]`);
        const editButton = this.querySelector(`[data-edit-panel="${panelName}"]`);
        if (!controls || !editButton) return;
        controls.hidden = false;
        editButton.hidden = true;
        editButton.setAttribute('aria-expanded', 'true');
        const selected = controls.querySelector('input:checked:not(:disabled)') || controls.querySelector('input:not(:disabled)');
        requestAnimationFrame(() => selected?.focus({ preventScroll: true }));
      }

      handleMainVariant(event) {
        const variant = event.detail?.variant;
        if (!variant?.id) return;
        this.mainVariantId = String(variant.id);
        this.mainPrice = Number(variant.price || 0);
        this.mainSize = Array.isArray(variant.options) ? String(variant.options[this.sizeOptionIndex] || '') : String(variant.title || '').split(' / ')[this.sizeOptionIndex] || '';
        this.querySelector('[data-main-price]').textContent = this.formatMoney(this.mainPrice);
        this.querySelector('[data-main-variant-title]').textContent = variant.title || '';
        this.syncSheetSize(this.mainSize);
        this.update();
      }

      normalise(value) { return String(value || '').trim().toLowerCase().replace(/\s+/g, ' '); }

      getSheetSelect(radio) { return this.querySelector(`[data-sheet-variants][data-product-id="${CSS.escape(radio.dataset.productId)}"]`); }

      getMatchingSheetOption(radio, size) {
        const select = this.getSheetSelect(radio);
        return Array.from(select?.options || []).find((option) => this.normalise(option.dataset.size || option.textContent) === this.normalise(size)) || null;
      }

      getSelectedSheetColour() { return this.querySelector('[data-sheet-colour]:checked')?.dataset.colour || ''; }

      getSheetRadios(depth) { return Array.from(this.querySelectorAll(depth ? `[data-sheet-colour][data-depth="${CSS.escape(String(depth))}"]` : '[data-sheet-colour]')); }

      activateDepth(depth, preferredColour = '') {
        const depthRadio = this.querySelector(`[data-sheet-depth][value="${CSS.escape(String(depth))}"]`);
        if (!depthRadio || depthRadio.disabled) return;
        const candidates = this.getSheetRadios(depth).filter((radio) => !radio.disabled);
        const selected = candidates.find((radio) => radio.dataset.colour === preferredColour) || candidates.find((radio) => radio.checked) || candidates[0];
        if (!selected) return;
        this.querySelectorAll('[data-sheet-depth]').forEach((radio) => { radio.checked = radio === depthRadio; });
        this.querySelectorAll('[data-sheet-colour]').forEach((radio) => { radio.checked = radio === selected; });
        this.querySelectorAll('[data-sheet-colour-option]').forEach((option) => { option.hidden = option.dataset.depth !== String(depth); });
        this.updateDepthPrices();
        this.syncPillowDepth(depth);
      }

      updateDepthPrices() {
        const colour = this.getSelectedSheetColour();
        this.querySelectorAll('[data-sheet-depth]').forEach((depthRadio) => {
          const candidates = this.getSheetRadios(depthRadio.value).filter((radio) => !radio.disabled);
          const candidate = candidates.find((radio) => radio.dataset.colour === colour) || candidates[0];
          const option = candidate ? this.getMatchingSheetOption(candidate, this.mainSize) : null;
          const output = this.querySelector(`[data-depth-price="${CSS.escape(depthRadio.value)}"]`);
          if (output) output.textContent = option ? this.formatMoney(Number(option.dataset.price || 0)) : '';
        });
      }

      syncSheetSize(size) {
        this.querySelectorAll('[data-sheet-colour]').forEach((radio) => {
          const option = this.getMatchingSheetOption(radio, size);
          radio.disabled = !option;
          if (option) this.getSheetSelect(radio).value = option.value;
        });
        this.querySelectorAll('[data-sheet-depth]').forEach((radio) => {
          radio.disabled = !this.getSheetRadios(radio.value).some((colour) => !colour.disabled);
          radio.closest('.bedding-ladder__choice').hidden = radio.disabled;
        });
        let selectedDepth = this.querySelector(`[data-sheet-depth][value="${CSS.escape(this.defaultDepth)}"]:not(:disabled)`) || this.querySelector('[data-sheet-depth]:not(:disabled)');
        if (selectedDepth) this.activateDepth(selectedDepth.value, this.getSelectedSheetColour());
      }

      getSelectedSheet() {
        const radio = this.querySelector('[data-sheet-colour]:checked:not(:disabled)');
        const option = radio ? this.getSheetSelect(radio)?.selectedOptions?.[0] : null;
        if (!radio || !option) return null;
        return { id:option.value, price:Number(option.dataset.price || 0), size:option.dataset.size || option.textContent, depth:radio.dataset.depth || '', colour:radio.dataset.colour || '', imageSrc:radio.dataset.imageSrc || '', imageAlt:radio.dataset.sheetTitle || '' };
      }

      getPillowOption() {
        const colourRadio = this.querySelector('[data-pillow-colour]:checked:not(:disabled)');
        const colour = colourRadio?.dataset.colour || colourRadio?.value;
        const depth = colourRadio?.dataset.depth || 'all';
        const style = this.querySelector('[data-pillow-style]:checked:not(:disabled)')?.value;
        return Array.from(this.querySelector('[data-pillow-variants]')?.options || []).find((option) => option.dataset.colour === colour && option.dataset.style === style && option.dataset.depth === depth) || null;
      }

      syncPillowDepth(depth) {
        const radios = Array.from(this.querySelectorAll('[data-pillow-colour]'));
        const currentColour = this.querySelector('[data-pillow-colour]:checked')?.dataset.colour || '';
        const candidates = radios.filter((radio) => radio.dataset.depth === 'all' || radio.dataset.depth === String(depth));
        radios.forEach((radio) => {
          const availableForDepth = candidates.includes(radio);
          radio.disabled = !availableForDepth;
          radio.closest('[data-pillow-colour-option]').hidden = !availableForDepth;
        });
        const selected = candidates.find((radio) => radio.dataset.colour === currentColour) || candidates.find((radio) => radio.checked) || candidates.find((radio) => radio.dataset.colour === 'White') || candidates[0];
        if (selected) radios.forEach((radio) => { radio.checked = radio === selected; });
        this.syncPillowStyles();
      }

      syncPillowStyles() {
        const colourRadio = this.querySelector('[data-pillow-colour]:checked:not(:disabled)');
        const colour = colourRadio?.dataset.colour || colourRadio?.value;
        const depth = colourRadio?.dataset.depth || 'all';
        const options = Array.from(this.querySelector('[data-pillow-variants]')?.options || []);
        this.querySelectorAll('[data-pillow-style]').forEach((radio) => { radio.disabled = !options.some((option) => option.dataset.colour === colour && option.dataset.style === radio.value && option.dataset.depth === depth); });
        if (!this.querySelector('[data-pillow-style]:checked:not(:disabled)')) {
          const available = this.querySelector('[data-pillow-style]:not(:disabled)');
          if (available) available.checked = true;
        }
      }

      update() {
        const includeSheet = this.querySelector('[data-include-sheet]').checked;
        const includePillow = includeSheet && this.querySelector('[data-include-pillow]').checked;
        const sheet = this.getSelectedSheet();
        const pillow = this.getPillowOption();
        const sheetControls = this.querySelector('[data-sheet-controls]');
        const pillowControls = this.querySelector('[data-pillow-controls]');
        sheetControls.classList.toggle('is-disabled', !includeSheet);
        pillowControls.classList.toggle('is-disabled', !includePillow);
        this.querySelector('[data-sheet-state]').textContent = includeSheet ? 'Added to set' : 'Add to set';
        this.querySelector('[data-pillow-state]').textContent = includePillow ? 'Added to set' : 'Add to set';

        if (sheet) {
          const depthLabel = this.querySelector(`[data-sheet-depth][value="${CSS.escape(sheet.depth)}"]`)?.dataset.summaryLabel || sheet.depth;
          this.querySelector('[data-sheet-summary]').textContent = `${sheet.size} · ${depthLabel} · ${sheet.colour}`;
          this.querySelector('[data-sheet-price]').textContent = this.formatMoney(sheet.price);
          const image = this.querySelector('[data-sheet-image]');
          if (image && sheet.imageSrc) { image.src = sheet.imageSrc; image.alt = sheet.imageAlt; }
        } else {
          this.querySelector('[data-sheet-summary]').textContent = this.dataset.unavailableText;
        }

        if (pillow) {
          this.querySelector('[data-pillow-variants]').value = pillow.value;
          this.querySelector('[data-pillow-summary]').textContent = `${pillow.dataset.colour} · ${pillow.dataset.style}`;
          this.querySelector('[data-pillow-price]').textContent = this.formatMoney(Number(pillow.dataset.price || 0));
          const image = this.querySelector('[data-pillow-image]');
          if (image && pillow.dataset.imageSrc) image.src = pillow.dataset.imageSrc;
        }

        const percent = includePillow ? 10 : includeSheet ? 5 : 0;
        const subtotal = this.mainPrice + (includeSheet && sheet ? sheet.price : 0) + (includePillow && pillow ? Number(pillow.dataset.price || 0) : 0);
        const saving = Math.round(subtotal * percent / 100);
        const total = subtotal - saving;
        this.querySelector('[data-bundle-subtotal]').textContent = this.formatMoney(subtotal);
        this.querySelector('[data-bundle-total]').textContent = this.formatMoney(total);
        this.querySelector('[data-bundle-saving]').textContent = this.formatMoney(saving);
        this.querySelector('[data-total-label]').textContent = percent ? `${percent === 10 ? 'Complete set' : 'Duvet and sheet'} total (${percent}% off)` : 'Duvet total';
        this.button.textContent = percent === 10 ? this.dataset.buttonComplete : percent === 5 ? this.dataset.buttonSheet : this.dataset.buttonDuvet;
        this.button.disabled = !this.mainVariantId || (includeSheet && !sheet) || (includePillow && !pillow);
        this.querySelector('[data-progress-fill]').style.transform = `scaleX(${percent / 10})`;
        this.querySelectorAll('[data-progress-step]').forEach((step) => {
          const value = Number(step.dataset.progressStep);
          step.classList.toggle('is-active', value <= percent);
          step.classList.toggle('is-current', value === percent);
        });
      }

      async addToCart() {
        const includeSheet = this.querySelector('[data-include-sheet]').checked;
        const includePillow = includeSheet && this.querySelector('[data-include-pillow]').checked;
        const sheet = this.getSelectedSheet();
        const pillow = this.getPillowOption();
        const defaultText = this.button.textContent;
        const items = [{ id:this.mainVariantId, quantity:1 }];
        if (includeSheet && sheet) items.push({ id:sheet.id, quantity:1 });
        if (includePillow && pillow) items.push({ id:pillow.value, quantity:1 });
        this.button.disabled = true;
        this.button.textContent = this.dataset.loadingText;
        this.status.textContent = '';
        this.status.className = 'bedding-ladder__status';
        try {
          const response = await fetch(`${this.dataset.rootUrl}cart/add.js`, { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json', 'X-Requested-With':'XMLHttpRequest' }, body:JSON.stringify({ items }) });
          if (!response.ok) throw new Error('Bedding set add failed');
          this.status.textContent = this.dataset.successText;
          this.status.classList.add('is-success');
          if (document.querySelector('cart-drawer')) {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
          } else {
            window.location.assign(`${this.dataset.rootUrl}cart`);
          }
        } catch (error) {
          this.status.textContent = this.dataset.errorText;
          this.status.classList.add('is-error');
        } finally {
          this.button.textContent = defaultText;
          this.update();
        }
      }

      formatMoney(cents) {
        const currency = window.Shopify?.currency?.active || 'GBP';
        const locale = document.documentElement.lang || 'en-GB';
        return new Intl.NumberFormat(locale, { style:'currency', currency }).format(cents / 100);
      }
    }
    customElements.define('supplier-bedding-ladder', SupplierBeddingLadder);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-bundle-builder-bianca"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bianca-bundle-builder')) {
    class BiancaBundleBuilder extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;
        this.discountPercent = Number(this.dataset.discountPercent || 0);
        this.sizeOptionIndex = Number(this.dataset.sizeOptionIndex || 0);
        this.mainVariantId = this.dataset.mainVariant;
        this.mainPrice = Number(this.dataset.mainPrice || 0);
        this.mainSize = this.dataset.mainSize || '';
        this.button = this.querySelector('[data-bundle-submit]');
        this.status = this.querySelector('[data-bundle-status]');
        this.changeHandler = (event) => {
          if (event.target.matches('[data-sheet-depth]')) {
            this.selectDepth(event.target.value);
          }
          if (event.target.matches('[data-sheet-colour]')) {
            this.updateDepthPrices();
            this.update();
          }
        };
        this.variantHandler = (event) => this.handleMainVariant(event);
        this.addHandler = () => this.addToCart();
        this.addEventListener('change', this.changeHandler);
        this.button.addEventListener('click', this.addHandler);
        document.addEventListener('on:variant:change', this.variantHandler);
        this.syncSheetSize(this.mainSize);
        this.update();
        this.hidden = false;
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.changeHandler);
        this.button?.removeEventListener('click', this.addHandler);
        document.removeEventListener('on:variant:change', this.variantHandler);
      }

      handleMainVariant(event) {
        const variant = event.detail?.variant;
        if (!variant?.id) return;
        this.mainVariantId = String(variant.id);
        this.mainPrice = Number(variant.price || 0);
        this.mainSize = this.getMainSize(variant);
        const mainPrice = this.querySelector('[data-main-price]');
        const mainTitle = this.querySelector('[data-main-variant-title]');
        if (mainPrice) mainPrice.textContent = this.formatMoney(this.mainPrice);
        if (mainTitle) mainTitle.textContent = variant.title || '';
        this.syncSheetSize(this.mainSize);
        this.update();
      }

      getMainSize(variant) {
        if (Array.isArray(variant.options) && variant.options[this.sizeOptionIndex]) {
          return String(variant.options[this.sizeOptionIndex]);
        }
        return String(variant.title || '').split(' / ')[this.sizeOptionIndex] || '';
      }

      normaliseSize(value) {
        return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
      }

      getSelect(radio) {
        return this.querySelector(`[data-sheet-variants][data-product-id="${CSS.escape(radio.dataset.productId)}"]`);
      }

      getMatchingOption(radio, size) {
        const select = this.getSelect(radio);
        if (!select) return null;
        return Array.from(select.options).find((option) => {
          return this.normaliseSize(option.dataset.size || option.textContent) === this.normaliseSize(size);
        }) || null;
      }

      getSelectedColour() {
        return this.querySelector('[data-sheet-colour]:checked')?.dataset.colour || '';
      }

      getDepthRadio(depth) {
        return this.querySelector(`[data-sheet-depth][value="${CSS.escape(String(depth))}"]`);
      }

      getSheetRadios(depth) {
        const selector = depth ? `[data-sheet-colour][data-depth="${CSS.escape(String(depth))}"]` : '[data-sheet-colour]';
        return Array.from(this.querySelectorAll(selector));
      }

      selectDepth(depth) {
        this.activateDepth(depth, this.getSelectedColour());
      }

      activateDepth(depth, preferredColour = '') {
        const depthRadio = this.getDepthRadio(depth);
        if (!depthRadio || depthRadio.disabled) return;
        const candidates = this.getSheetRadios(depth).filter((radio) => !radio.disabled);
        if (!candidates.length) return;
        let selected = candidates.find((radio) => radio.dataset.colour === preferredColour);
        if (!selected) selected = candidates.find((radio) => radio.checked) || candidates[0];
        this.querySelectorAll('[data-sheet-depth]').forEach((radio) => { radio.checked = radio === depthRadio; });
        this.querySelectorAll('[data-sheet-colour]').forEach((radio) => { radio.checked = radio === selected; });
        this.querySelectorAll('[data-sheet-colour-option]').forEach((option) => {
          option.hidden = option.dataset.depth !== String(depth);
        });
        this.updateDepthPrices();
        this.update();
      }

      updateDepthPrices() {
        const selectedColour = this.getSelectedColour();
        this.querySelectorAll('[data-sheet-depth]').forEach((depthRadio) => {
          const candidates = this.getSheetRadios(depthRadio.value).filter((radio) => !radio.disabled);
          let candidate = candidates.find((radio) => radio.dataset.colour === selectedColour);
          if (!candidate) candidate = candidates[0];
          const option = candidate ? this.getMatchingOption(candidate, this.mainSize) : null;
          const price = this.querySelector(`[data-depth-price="${CSS.escape(depthRadio.value)}"]`);
          if (price) price.textContent = option ? this.formatMoney(Number(option.dataset.price || 0)) : '';
        });
      }

      syncSheetSize(size) {
        const radios = Array.from(this.querySelectorAll('[data-sheet-colour]'));
        radios.forEach((radio) => {
          const option = this.getMatchingOption(radio, size);
          radio.disabled = !option;
          if (option) this.getSelect(radio).value = option.value;
        });

        this.querySelectorAll('[data-sheet-depth]').forEach((depthRadio) => {
          depthRadio.disabled = !this.getSheetRadios(depthRadio.value).some((radio) => !radio.disabled);
          const depthOption = depthRadio.closest('.bianca-bundle__depth-option');
          if (depthOption) depthOption.hidden = depthRadio.disabled;
        });

        let selectedDepth = this.getDepthRadio('32');
        if (selectedDepth?.disabled) selectedDepth = this.querySelector('[data-sheet-depth]:not(:disabled)');
        if (selectedDepth) this.activateDepth(selectedDepth.value, this.getSelectedColour());
      }

      getSelectedSheet() {
        const radio = this.querySelector('[data-sheet-colour]:checked:not(:disabled)');
        if (!radio) return null;
        const select = this.getSelect(radio);
        const option = select?.selectedOptions?.[0];
        if (!option) return null;
        return {
          id: option.value,
          price: Number(option.dataset.price || 0),
          size: option.dataset.size || option.textContent,
          depth: radio.dataset.depth || '',
          colour: radio.dataset.colour || '',
          imageSrc: radio.dataset.imageSrc || '',
          imageAlt: radio.dataset.sheetTitle || ''
        };
      }

      update() {
        const sheet = this.getSelectedSheet();
        const image = this.querySelector('[data-bianca-sheet-image]');
        const colourText = this.querySelector('[data-sheet-colour-text]');
        const sizeText = this.querySelector('[data-sheet-size-text]');
        const sheetPrice = this.querySelector('[data-sheet-price]');

        if (sheet) {
          if (image && sheet.imageSrc) {
            image.src = sheet.imageSrc;
            image.alt = sheet.imageAlt;
          }
          const depthLabel = this.dataset.depthLabel;
          if (colourText) colourText.textContent = `${this.dataset.selectedPrefix}: ${depthLabel} · ${sheet.colour}`;
          if (sizeText) sizeText.textContent = `${this.dataset.sizeMatchedPrefix}: ${sheet.size}`;
          if (sheetPrice) sheetPrice.textContent = this.formatMoney(sheet.price);
        } else {
          if (colourText) colourText.textContent = '';
          if (sizeText) sizeText.textContent = this.dataset.unavailableText || '';
          if (sheetPrice) sheetPrice.textContent = '';
        }

        const subtotal = sheet ? this.mainPrice + sheet.price : this.mainPrice;
        const mainSaving = sheet ? Math.floor(this.mainPrice * this.discountPercent / 100) : 0;
        const sheetSaving = sheet ? Math.floor(sheet.price * this.discountPercent / 100) : 0;
        const saving = mainSaving + sheetSaving;
        const total = subtotal - saving;
        this.querySelector('[data-bundle-subtotal]').textContent = this.formatMoney(subtotal);
        this.querySelector('[data-bundle-total]').textContent = this.formatMoney(total);
        this.querySelector('[data-bundle-saving]').textContent = this.formatMoney(saving);
        this.button.disabled = !sheet || !this.mainVariantId;
      }

      async addToCart() {
        const sheet = this.getSelectedSheet();
        if (!sheet || !this.mainVariantId) return;
        const defaultText = this.dataset.buttonText;
        this.button.disabled = true;
        this.button.textContent = this.dataset.loadingText;
        this.status.textContent = '';
        this.status.className = 'bianca-bundle__status';

        try {
          const response = await fetch(`${this.dataset.rootUrl}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [
                { id: this.mainVariantId, quantity: 1 },
                { id: sheet.id, quantity: 1 }
              ]
            })
          });

          if (!response.ok) throw new Error('Bundle add failed');
          this.status.textContent = this.dataset.successText;
          this.status.classList.add('is-success');

          if (document.querySelector('cart-drawer')) {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
          } else {
            window.location.assign(`${this.dataset.rootUrl}cart`);
          }
        } catch (error) {
          this.status.textContent = this.dataset.errorText;
          this.status.classList.add('is-error');
        } finally {
          this.button.textContent = defaultText;
          this.update();
        }
      }

      formatMoney(cents) {
        const currency = window.Shopify?.currency?.active || 'GBP';
        const locale = document.documentElement.lang || 'en-GB';
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency
        }).format(cents / 100);
      }
    }

    customElements.define('bianca-bundle-builder', BiancaBundleBuilder);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-bundle-builder-rapport"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rapport-bundle-builder')) {
    class RapportBundleBuilder extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;
        this.discountPercent = Number(this.dataset.discountPercent || 0);
        this.sizeOptionIndex = Number(this.dataset.sizeOptionIndex || 0);
        this.mainVariantId = this.dataset.mainVariant;
        this.mainPrice = Number(this.dataset.mainPrice || 0);
        this.mainSize = this.dataset.mainSize || '';
        this.button = this.querySelector('[data-bundle-submit]');
        this.status = this.querySelector('[data-bundle-status]');
        this.changeHandler = (event) => {
          if (event.target.matches('[data-sheet-depth]')) {
            this.selectDepth(event.target.value);
          }
          if (event.target.matches('[data-sheet-colour]')) {
            this.updateDepthPrices();
            this.update();
          }
        };
        this.variantHandler = (event) => this.handleMainVariant(event);
        this.addHandler = () => this.addToCart();
        this.addEventListener('change', this.changeHandler);
        this.button.addEventListener('click', this.addHandler);
        document.addEventListener('on:variant:change', this.variantHandler);
        this.syncSheetSize(this.mainSize);
        this.update();
        this.hidden = false;
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.changeHandler);
        this.button?.removeEventListener('click', this.addHandler);
        document.removeEventListener('on:variant:change', this.variantHandler);
      }

      handleMainVariant(event) {
        const variant = event.detail?.variant;
        if (!variant?.id) return;
        this.mainVariantId = String(variant.id);
        this.mainPrice = Number(variant.price || 0);
        this.mainSize = this.getMainSize(variant);
        const mainPrice = this.querySelector('[data-main-price]');
        const mainTitle = this.querySelector('[data-main-variant-title]');
        if (mainPrice) mainPrice.textContent = this.formatMoney(this.mainPrice);
        if (mainTitle) mainTitle.textContent = variant.title || '';
        this.syncSheetSize(this.mainSize);
        this.update();
      }

      getMainSize(variant) {
        if (Array.isArray(variant.options) && variant.options[this.sizeOptionIndex]) {
          return String(variant.options[this.sizeOptionIndex]);
        }
        return String(variant.title || '').split(' / ')[this.sizeOptionIndex] || '';
      }

      normaliseSize(value) {
        return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
      }

      getSelect(radio) {
        return this.querySelector(`[data-sheet-variants][data-product-id="${CSS.escape(radio.dataset.productId)}"]`);
      }

      getMatchingOption(radio, size) {
        const select = this.getSelect(radio);
        if (!select) return null;
        return Array.from(select.options).find((option) => {
          return this.normaliseSize(option.dataset.size || option.textContent) === this.normaliseSize(size);
        }) || null;
      }

      getSelectedColour() {
        return this.querySelector('[data-sheet-colour]:checked')?.dataset.colour || '';
      }

      getDepthRadio(depth) {
        return this.querySelector(`[data-sheet-depth][value="${CSS.escape(String(depth))}"]`);
      }

      getSheetRadios(depth) {
        const selector = depth ? `[data-sheet-colour][data-depth="${CSS.escape(String(depth))}"]` : '[data-sheet-colour]';
        return Array.from(this.querySelectorAll(selector));
      }

      selectDepth(depth) {
        this.activateDepth(depth, this.getSelectedColour());
      }

      activateDepth(depth, preferredColour = '') {
        const depthRadio = this.getDepthRadio(depth);
        if (!depthRadio || depthRadio.disabled) return;
        const candidates = this.getSheetRadios(depth).filter((radio) => !radio.disabled);
        if (!candidates.length) return;
        let selected = candidates.find((radio) => radio.dataset.colour === preferredColour);
        if (!selected) selected = candidates.find((radio) => radio.checked) || candidates[0];
        this.querySelectorAll('[data-sheet-depth]').forEach((radio) => { radio.checked = radio === depthRadio; });
        this.querySelectorAll('[data-sheet-colour]').forEach((radio) => { radio.checked = radio === selected; });
        this.querySelectorAll('[data-sheet-colour-option]').forEach((option) => {
          option.hidden = option.dataset.depth !== String(depth);
        });
        this.updateDepthPrices();
        this.update();
      }

      updateDepthPrices() {
        const selectedColour = this.getSelectedColour();
        this.querySelectorAll('[data-sheet-depth]').forEach((depthRadio) => {
          const candidates = this.getSheetRadios(depthRadio.value).filter((radio) => !radio.disabled);
          let candidate = candidates.find((radio) => radio.dataset.colour === selectedColour);
          if (!candidate) candidate = candidates[0];
          const option = candidate ? this.getMatchingOption(candidate, this.mainSize) : null;
          const price = this.querySelector(`[data-depth-price="${CSS.escape(depthRadio.value)}"]`);
          if (price) price.textContent = option ? this.formatMoney(Number(option.dataset.price || 0)) : '';
        });
      }

      syncSheetSize(size) {
        const radios = Array.from(this.querySelectorAll('[data-sheet-colour]'));
        radios.forEach((radio) => {
          const option = this.getMatchingOption(radio, size);
          radio.disabled = !option;
          if (option) this.getSelect(radio).value = option.value;
        });

        this.querySelectorAll('[data-sheet-depth]').forEach((depthRadio) => {
          depthRadio.disabled = !this.getSheetRadios(depthRadio.value).some((radio) => !radio.disabled);
        });

        let selectedDepth = this.querySelector('[data-sheet-depth]:checked:not(:disabled)');
        if (!selectedDepth) selectedDepth = this.getDepthRadio('40');
        if (selectedDepth?.disabled) selectedDepth = this.querySelector('[data-sheet-depth]:not(:disabled)');
        if (selectedDepth) this.activateDepth(selectedDepth.value, this.getSelectedColour());
      }

      getSelectedSheet() {
        const radio = this.querySelector('[data-sheet-colour]:checked:not(:disabled)');
        if (!radio) return null;
        const select = this.getSelect(radio);
        const option = select?.selectedOptions?.[0];
        if (!option) return null;
        return {
          id: option.value,
          price: Number(option.dataset.price || 0),
          size: option.dataset.size || option.textContent,
          depth: radio.dataset.depth || '',
          colour: radio.dataset.colour || '',
          imageSrc: radio.dataset.imageSrc || '',
          imageAlt: radio.dataset.sheetTitle || ''
        };
      }

      update() {
        const sheet = this.getSelectedSheet();
        const image = this.querySelector('[data-rapport-sheet-image]');
        const colourText = this.querySelector('[data-sheet-colour-text]');
        const sizeText = this.querySelector('[data-sheet-size-text]');
        const sheetPrice = this.querySelector('[data-sheet-price]');

        if (sheet) {
          if (image && sheet.imageSrc) {
            image.src = sheet.imageSrc;
            image.alt = sheet.imageAlt;
          }
          const depthLabel = sheet.depth === '40' ? this.dataset.extraDepthLabel : this.dataset.standardDepthLabel;
          if (colourText) colourText.textContent = `${this.dataset.selectedPrefix}: ${depthLabel} · ${sheet.colour}`;
          if (sizeText) sizeText.textContent = `${this.dataset.sizeMatchedPrefix}: ${sheet.size}`;
          if (sheetPrice) sheetPrice.textContent = this.formatMoney(sheet.price);
        } else {
          if (colourText) colourText.textContent = '';
          if (sizeText) sizeText.textContent = this.dataset.unavailableText || '';
          if (sheetPrice) sheetPrice.textContent = '';
        }

        const subtotal = sheet ? this.mainPrice + sheet.price : this.mainPrice;
        const mainSaving = sheet ? Math.floor(this.mainPrice * this.discountPercent / 100) : 0;
        const sheetSaving = sheet ? Math.floor(sheet.price * this.discountPercent / 100) : 0;
        const saving = mainSaving + sheetSaving;
        const total = subtotal - saving;
        this.querySelector('[data-bundle-subtotal]').textContent = this.formatMoney(subtotal);
        this.querySelector('[data-bundle-total]').textContent = this.formatMoney(total);
        this.querySelector('[data-bundle-saving]').textContent = this.formatMoney(saving);
        this.button.disabled = !sheet || !this.mainVariantId;
      }

      async addToCart() {
        const sheet = this.getSelectedSheet();
        if (!sheet || !this.mainVariantId) return;
        const defaultText = this.dataset.buttonText;
        this.button.disabled = true;
        this.button.textContent = this.dataset.loadingText;
        this.status.textContent = '';
        this.status.className = 'rapport-bundle__status';

        try {
          const response = await fetch(`${this.dataset.rootUrl}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [
                { id: this.mainVariantId, quantity: 1 },
                { id: sheet.id, quantity: 1 }
              ]
            })
          });

          if (!response.ok) throw new Error('Bundle add failed');
          this.status.textContent = this.dataset.successText;
          this.status.classList.add('is-success');

          if (document.querySelector('cart-drawer')) {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
          } else {
            window.location.assign(`${this.dataset.rootUrl}cart`);
          }
        } catch (error) {
          this.status.textContent = this.dataset.errorText;
          this.status.classList.add('is-error');
        } finally {
          this.button.textContent = defaultText;
          this.update();
        }
      }

      formatMoney(cents) {
        const currency = window.Shopify?.currency?.active || 'GBP';
        const locale = document.documentElement.lang || 'en-GB';
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency
        }).format(cents / 100);
      }
    }

    customElements.define('rapport-bundle-builder', RapportBundleBuilder);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-bundle-builder-turner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('turner-bundle-builder')) {
    class TurnerBundleBuilder extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;
        this.discountPercent = Number(this.dataset.discountPercent || 0);
        this.sizeOptionIndex = Number(this.dataset.sizeOptionIndex || 0);
        this.mainVariantId = this.dataset.mainVariant;
        this.mainPrice = Number(this.dataset.mainPrice || 0);
        this.mainSize = this.dataset.mainSize || '';
        this.button = this.querySelector('[data-bundle-submit]');
        this.status = this.querySelector('[data-bundle-status]');
        this.changeHandler = (event) => {
          if (event.target.matches('[data-sheet-depth]')) {
            this.selectDepth(event.target.value);
          }
          if (event.target.matches('[data-sheet-colour]')) {
            this.updateDepthPrices();
            this.update();
          }
        };
        this.variantHandler = (event) => this.handleMainVariant(event);
        this.addHandler = () => this.addToCart();
        this.addEventListener('change', this.changeHandler);
        this.button.addEventListener('click', this.addHandler);
        document.addEventListener('on:variant:change', this.variantHandler);
        this.syncSheetSize(this.mainSize);
        this.update();
        this.hidden = false;
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.changeHandler);
        this.button?.removeEventListener('click', this.addHandler);
        document.removeEventListener('on:variant:change', this.variantHandler);
      }

      handleMainVariant(event) {
        const variant = event.detail?.variant;
        if (!variant?.id) return;
        this.mainVariantId = String(variant.id);
        this.mainPrice = Number(variant.price || 0);
        this.mainSize = this.getMainSize(variant);
        const mainPrice = this.querySelector('[data-main-price]');
        const mainTitle = this.querySelector('[data-main-variant-title]');
        if (mainPrice) mainPrice.textContent = this.formatMoney(this.mainPrice);
        if (mainTitle) mainTitle.textContent = variant.title || '';
        this.syncSheetSize(this.mainSize);
        this.update();
      }

      getMainSize(variant) {
        if (Array.isArray(variant.options) && variant.options[this.sizeOptionIndex]) {
          return String(variant.options[this.sizeOptionIndex]);
        }
        return String(variant.title || '').split(' / ')[this.sizeOptionIndex] || '';
      }

      normaliseSize(value) {
        return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
      }

      getSelect(radio) {
        return this.querySelector(`[data-sheet-variants][data-product-id="${CSS.escape(radio.dataset.productId)}"]`);
      }

      getMatchingOption(radio, size) {
        const select = this.getSelect(radio);
        if (!select) return null;
        return Array.from(select.options).find((option) => {
          return this.normaliseSize(option.dataset.size || option.textContent) === this.normaliseSize(size);
        }) || null;
      }

      getSelectedColour() {
        return this.querySelector('[data-sheet-colour]:checked')?.dataset.colour || '';
      }

      getDepthRadio(depth) {
        return this.querySelector(`[data-sheet-depth][value="${CSS.escape(String(depth))}"]`);
      }

      getSheetRadios(depth) {
        const selector = depth ? `[data-sheet-colour][data-depth="${CSS.escape(String(depth))}"]` : '[data-sheet-colour]';
        return Array.from(this.querySelectorAll(selector));
      }

      selectDepth(depth) {
        this.activateDepth(depth, this.getSelectedColour());
      }

      activateDepth(depth, preferredColour = '') {
        const depthRadio = this.getDepthRadio(depth);
        if (!depthRadio || depthRadio.disabled) return;
        const candidates = this.getSheetRadios(depth).filter((radio) => !radio.disabled);
        if (!candidates.length) return;
        let selected = candidates.find((radio) => radio.dataset.colour === preferredColour);
        if (!selected) selected = candidates.find((radio) => radio.checked) || candidates[0];
        this.querySelectorAll('[data-sheet-depth]').forEach((radio) => { radio.checked = radio === depthRadio; });
        this.querySelectorAll('[data-sheet-colour]').forEach((radio) => { radio.checked = radio === selected; });
        this.querySelectorAll('[data-sheet-colour-option]').forEach((option) => {
          option.hidden = option.dataset.depth !== String(depth);
        });
        this.updateDepthPrices();
        this.update();
      }

      updateDepthPrices() {
        const selectedColour = this.getSelectedColour();
        this.querySelectorAll('[data-sheet-depth]').forEach((depthRadio) => {
          const candidates = this.getSheetRadios(depthRadio.value).filter((radio) => !radio.disabled);
          let candidate = candidates.find((radio) => radio.dataset.colour === selectedColour);
          if (!candidate) candidate = candidates[0];
          const option = candidate ? this.getMatchingOption(candidate, this.mainSize) : null;
          const price = this.querySelector(`[data-depth-price="${CSS.escape(depthRadio.value)}"]`);
          if (price) price.textContent = option ? this.formatMoney(Number(option.dataset.price || 0)) : '';
        });
      }

      syncSheetSize(size) {
        const radios = Array.from(this.querySelectorAll('[data-sheet-colour]'));
        radios.forEach((radio) => {
          const option = this.getMatchingOption(radio, size);
          radio.disabled = !option;
          if (option) this.getSelect(radio).value = option.value;
        });

        this.querySelectorAll('[data-sheet-depth]').forEach((depthRadio) => {
          depthRadio.disabled = !this.getSheetRadios(depthRadio.value).some((radio) => !radio.disabled);
          const depthOption = depthRadio.closest('.turner-bundle__depth-option');
          if (depthOption) depthOption.hidden = depthRadio.disabled;
        });

        let selectedDepth = this.getDepthRadio('35');
        if (selectedDepth?.disabled) selectedDepth = this.querySelector('[data-sheet-depth]:not(:disabled)');
        if (selectedDepth) this.activateDepth(selectedDepth.value, this.getSelectedColour());
      }

      getSelectedSheet() {
        const radio = this.querySelector('[data-sheet-colour]:checked:not(:disabled)');
        if (!radio) return null;
        const select = this.getSelect(radio);
        const option = select?.selectedOptions?.[0];
        if (!option) return null;
        return {
          id: option.value,
          price: Number(option.dataset.price || 0),
          size: option.dataset.size || option.textContent,
          depth: radio.dataset.depth || '',
          colour: radio.dataset.colour || '',
          imageSrc: radio.dataset.imageSrc || '',
          imageAlt: radio.dataset.sheetTitle || ''
        };
      }

      update() {
        const sheet = this.getSelectedSheet();
        const image = this.querySelector('[data-turner-sheet-image]');
        const colourText = this.querySelector('[data-sheet-colour-text]');
        const sizeText = this.querySelector('[data-sheet-size-text]');
        const sheetPrice = this.querySelector('[data-sheet-price]');

        if (sheet) {
          if (image && sheet.imageSrc) {
            image.src = sheet.imageSrc;
            image.alt = sheet.imageAlt;
          }
          const depthLabel = sheet.depth === '35' ? this.dataset.extraDepthLabel : this.dataset.standardDepthLabel;
          if (colourText) colourText.textContent = `${this.dataset.selectedPrefix}: ${depthLabel} · ${sheet.colour}`;
          if (sizeText) sizeText.textContent = `${this.dataset.sizeMatchedPrefix}: ${sheet.size}`;
          if (sheetPrice) sheetPrice.textContent = this.formatMoney(sheet.price);
        } else {
          if (colourText) colourText.textContent = '';
          if (sizeText) sizeText.textContent = this.dataset.unavailableText || '';
          if (sheetPrice) sheetPrice.textContent = '';
        }

        const subtotal = sheet ? this.mainPrice + sheet.price : this.mainPrice;
        const mainSaving = sheet ? Math.floor(this.mainPrice * this.discountPercent / 100) : 0;
        const sheetSaving = sheet ? Math.floor(sheet.price * this.discountPercent / 100) : 0;
        const saving = mainSaving + sheetSaving;
        const total = subtotal - saving;
        this.querySelector('[data-bundle-subtotal]').textContent = this.formatMoney(subtotal);
        this.querySelector('[data-bundle-total]').textContent = this.formatMoney(total);
        this.querySelector('[data-bundle-saving]').textContent = this.formatMoney(saving);
        this.button.disabled = !sheet || !this.mainVariantId;
      }

      async addToCart() {
        const sheet = this.getSelectedSheet();
        if (!sheet || !this.mainVariantId) return;
        const defaultText = this.dataset.buttonText;
        this.button.disabled = true;
        this.button.textContent = this.dataset.loadingText;
        this.status.textContent = '';
        this.status.className = 'turner-bundle__status';

        try {
          const response = await fetch(`${this.dataset.rootUrl}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [
                { id: this.mainVariantId, quantity: 1 },
                { id: sheet.id, quantity: 1 }
              ]
            })
          });

          if (!response.ok) throw new Error('Bundle add failed');
          this.status.textContent = this.dataset.successText;
          this.status.classList.add('is-success');

          if (document.querySelector('cart-drawer')) {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
          } else {
            window.location.assign(`${this.dataset.rootUrl}cart`);
          }
        } catch (error) {
          this.status.textContent = this.dataset.errorText;
          this.status.classList.add('is-error');
        } finally {
          this.button.textContent = defaultText;
          this.update();
        }
      }

      formatMoney(cents) {
        const currency = window.Shopify?.currency?.active || 'GBP';
        const locale = document.documentElement.lang || 'en-GB';
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency
        }).format(cents / 100);
      }
    }

    customElements.define('turner-bundle-builder', TurnerBundleBuilder);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-bundle-builder-uw"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('uw-bundle-builder')) {
    class UwBundleBuilder extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;
        this.discountPercent = Number(this.dataset.discountPercent || 0);
        this.sizeOptionIndex = Number(this.dataset.sizeOptionIndex || 0);
        this.mainVariantId = this.dataset.mainVariant;
        this.mainPrice = Number(this.dataset.mainPrice || 0);
        this.mainSize = this.dataset.mainSize || '';
        this.button = this.querySelector('[data-bundle-submit]');
        this.status = this.querySelector('[data-bundle-status]');
        this.changeHandler = (event) => {
          if (event.target.matches('[data-sheet-fit]')) this.selectFit(event.target.value);
          if (event.target.matches('[data-sheet-colour]')) {
            this.updateFitPrices();
            this.update();
          }
        };
        this.variantHandler = (event) => this.handleMainVariant(event);
        this.addHandler = () => this.addToCart();
        this.addEventListener('change', this.changeHandler);
        this.button.addEventListener('click', this.addHandler);
        document.addEventListener('on:variant:change', this.variantHandler);
        this.syncSheetSize(this.mainSize);
        this.update();
        this.hidden = false;
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.changeHandler);
        this.button?.removeEventListener('click', this.addHandler);
        document.removeEventListener('on:variant:change', this.variantHandler);
      }

      handleMainVariant(event) {
        const variant = event.detail?.variant;
        if (!variant?.id) return;
        this.mainVariantId = String(variant.id);
        this.mainPrice = Number(variant.price || 0);
        this.mainSize = this.getMainSize(variant);
        const mainPrice = this.querySelector('[data-main-price]');
        const mainTitle = this.querySelector('[data-main-variant-title]');
        if (mainPrice) mainPrice.textContent = this.formatMoney(this.mainPrice);
        if (mainTitle) mainTitle.textContent = variant.title || '';
        this.syncSheetSize(this.mainSize);
        this.update();
      }

      getMainSize(variant) {
        if (Array.isArray(variant.options) && variant.options[this.sizeOptionIndex]) {
          return String(variant.options[this.sizeOptionIndex]);
        }
        return String(variant.title || '').split(' / ')[this.sizeOptionIndex] || '';
      }

      normaliseSize(value) {
        return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
      }

      getSelect(radio) {
        return this.querySelector(`[data-sheet-variants][data-product-id="${CSS.escape(radio.dataset.productId)}"]`);
      }

      getMatchingOption(radio, size) {
        const select = this.getSelect(radio);
        if (!select) return null;
        return Array.from(select.options).find((option) => {
          return this.normaliseSize(option.dataset.size || option.textContent) === this.normaliseSize(size);
        }) || null;
      }

      getSelectedColour() {
        return this.querySelector('[data-sheet-colour]:checked')?.dataset.colour || '';
      }

      getFitRadio(fit) {
        return this.querySelector(`[data-sheet-fit][value="${CSS.escape(String(fit))}"]`);
      }

      getSheetRadios(fit) {
        const selector = fit ? `[data-sheet-colour][data-fit="${CSS.escape(String(fit))}"]` : '[data-sheet-colour]';
        return Array.from(this.querySelectorAll(selector));
      }

      selectFit(fit) {
        this.activateFit(fit, this.getSelectedColour());
      }

      activateFit(fit, preferredColour = '') {
        const fitRadio = this.getFitRadio(fit);
        if (!fitRadio || fitRadio.disabled) return;
        const candidates = this.getSheetRadios(fit).filter((radio) => !radio.disabled);
        if (!candidates.length) return;
        let selected = candidates.find((radio) => radio.dataset.colour === preferredColour);
        if (!selected) selected = candidates.find((radio) => radio.checked) || candidates[0];
        this.querySelectorAll('[data-sheet-fit]').forEach((radio) => { radio.checked = radio === fitRadio; });
        this.querySelectorAll('[data-sheet-colour]').forEach((radio) => { radio.checked = radio === selected; });
        this.querySelectorAll('[data-sheet-colour-option]').forEach((option) => {
          option.hidden = option.dataset.fit !== String(fit);
        });
        this.updateFitPrices();
        this.update();
      }

      updateFitPrices() {
        const selectedColour = this.getSelectedColour();
        this.querySelectorAll('[data-sheet-fit]').forEach((fitRadio) => {
          const candidates = this.getSheetRadios(fitRadio.value).filter((radio) => !radio.disabled);
          let candidate = candidates.find((radio) => radio.dataset.colour === selectedColour);
          if (!candidate) candidate = candidates[0];
          const option = candidate ? this.getMatchingOption(candidate, this.mainSize) : null;
          const price = this.querySelector(`[data-fit-price="${CSS.escape(fitRadio.value)}"]`);
          if (price) price.textContent = option ? this.formatMoney(Number(option.dataset.price || 0)) : '';
        });
      }

      syncSheetSize(size) {
        this.querySelectorAll('[data-sheet-colour]').forEach((radio) => {
          const option = this.getMatchingOption(radio, size);
          radio.disabled = !option;
          if (option) this.getSelect(radio).value = option.value;
        });

        this.querySelectorAll('[data-sheet-fit]').forEach((fitRadio) => {
          fitRadio.disabled = !this.getSheetRadios(fitRadio.value).some((radio) => !radio.disabled);
        });

        let selectedFit = this.querySelector('[data-sheet-fit]:checked:not(:disabled)');
        if (!selectedFit) selectedFit = this.getFitRadio('35');
        if (selectedFit?.disabled) selectedFit = this.getFitRadio('pattern');
        if (selectedFit?.disabled) selectedFit = this.getFitRadio('32');
        if (selectedFit?.disabled) selectedFit = this.querySelector('[data-sheet-fit]:not(:disabled)');
        if (selectedFit) this.activateFit(selectedFit.value, this.getSelectedColour());
      }

      getSelectedSheet() {
        const radio = this.querySelector('[data-sheet-colour]:checked:not(:disabled)');
        if (!radio) return null;
        const select = this.getSelect(radio);
        const option = select?.selectedOptions?.[0];
        if (!option) return null;
        return {
          id: option.value,
          price: Number(option.dataset.price || 0),
          size: option.dataset.size || option.textContent,
          fit: radio.dataset.fit || '',
          colour: radio.dataset.colour || '',
          imageSrc: radio.dataset.imageSrc || '',
          imageAlt: radio.dataset.sheetTitle || ''
        };
      }

      getFitLabel(fit) {
        if (fit === 'pattern') return this.dataset.patternLabel;
        if (fit === '32') return this.dataset.everydayLabel;
        return this.dataset.premiumLabel;
      }

      update() {
        const sheet = this.getSelectedSheet();
        const image = this.querySelector('[data-uw-sheet-image]');
        const choiceText = this.querySelector('[data-sheet-choice-text]');
        const sizeText = this.querySelector('[data-sheet-size-text]');
        const sheetPrice = this.querySelector('[data-sheet-price]');

        if (sheet) {
          if (image && sheet.imageSrc) {
            image.src = sheet.imageSrc;
            image.alt = sheet.imageAlt;
          }
          const fitLabel = this.getFitLabel(sheet.fit);
          const colourSuffix = sheet.fit === 'pattern' ? '' : ` · ${sheet.colour}`;
          if (choiceText) choiceText.textContent = `${this.dataset.selectedPrefix}: ${fitLabel}${colourSuffix}`;
          if (sizeText) sizeText.textContent = `${this.dataset.sizeMatchedPrefix}: ${sheet.size}`;
          if (sheetPrice) sheetPrice.textContent = this.formatMoney(sheet.price);
        } else {
          if (choiceText) choiceText.textContent = '';
          if (sizeText) sizeText.textContent = this.dataset.unavailableText || '';
          if (sheetPrice) sheetPrice.textContent = '';
        }

        const subtotal = sheet ? this.mainPrice + sheet.price : this.mainPrice;
        const mainSaving = sheet ? Math.floor(this.mainPrice * this.discountPercent / 100) : 0;
        const sheetSaving = sheet ? Math.floor(sheet.price * this.discountPercent / 100) : 0;
        const saving = mainSaving + sheetSaving;
        const total = subtotal - saving;
        this.querySelector('[data-bundle-subtotal]').textContent = this.formatMoney(subtotal);
        this.querySelector('[data-bundle-total]').textContent = this.formatMoney(total);
        this.querySelector('[data-bundle-saving]').textContent = this.formatMoney(saving);
        this.button.disabled = !sheet || !this.mainVariantId;
      }

      async addToCart() {
        const sheet = this.getSelectedSheet();
        if (!sheet || !this.mainVariantId) return;
        const defaultText = this.dataset.buttonText;
        this.button.disabled = true;
        this.button.textContent = this.dataset.loadingText;
        this.status.textContent = '';
        this.status.className = 'uw-bundle__status';

        try {
          const response = await fetch(`${this.dataset.rootUrl}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [
                { id: this.mainVariantId, quantity: 1 },
                { id: sheet.id, quantity: 1 }
              ]
            })
          });

          if (!response.ok) throw new Error('Bundle add failed');
          this.status.textContent = this.dataset.successText;
          this.status.classList.add('is-success');

          if (document.querySelector('cart-drawer')) {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
          } else {
            window.location.assign(`${this.dataset.rootUrl}cart`);
          }
        } catch (error) {
          this.status.textContent = this.dataset.errorText;
          this.status.classList.add('is-error');
        } finally {
          this.button.textContent = defaultText;
          this.update();
        }
      }

      formatMoney(cents) {
        const currency = window.Shopify?.currency?.active || 'GBP';
        const locale = document.documentElement.lang || 'en-GB';
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
      }
    }

    customElements.define('uw-bundle-builder', UwBundleBuilder);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-bundle-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-bundle-builder')) {
    class ProductBundleBuilder extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;
        const launchEndsAt = Date.parse(this.dataset.launchEndsAt || '');
        if (Number.isFinite(launchEndsAt)) {
          const remaining = launchEndsAt - Date.now();
          if (remaining <= 0) {
            this.remove();
            return;
          }
          this.launchExpiryTimer = window.setTimeout(() => this.remove(), remaining);
        }
        this.discountPercent = Number(this.dataset.discountPercent || 0);
        this.progressTemplate = this.dataset.progressTemplate;
        this.button = this.querySelector('[data-bundle-submit]');
        this.status = this.querySelector('[data-bundle-status]');
        this.mainVariantId = this.dataset.mainVariant;
        this.mainPrice = Number(this.dataset.mainPrice || 0);
        this.changeHandler = () => this.update();
        this.variantHandler = (event) => this.handleMainVariant(event);
        this.addHandler = () => this.addToCart();
        this.addEventListener('change', this.changeHandler);
        this.button.addEventListener('click', this.addHandler);
        document.addEventListener('on:variant:change', this.variantHandler);
        this.syncSheetSize(this.dataset.mainSize);
        this.update();
      }

      disconnectedCallback() {
        if (this.launchExpiryTimer) window.clearTimeout(this.launchExpiryTimer);
        this.removeEventListener('change', this.changeHandler);
        this.button?.removeEventListener('click', this.addHandler);
        document.removeEventListener('on:variant:change', this.variantHandler);
      }

      handleMainVariant(event) {
        const variant = event.detail?.variant;
        if (!variant?.id) return;
        this.mainVariantId = String(variant.id);
        this.mainPrice = Number(variant.price || 0);
        this.dataset.mainVariant = this.mainVariantId;
        this.dataset.mainPrice = String(this.mainPrice);
        const mainSize = this.getMainSize(variant);
        this.dataset.mainSize = mainSize;
        const mainPrice = this.querySelector('[data-main-price]');
        const mainTitle = this.querySelector('[data-main-variant-title]');
        if (mainPrice) mainPrice.textContent = this.formatMoney(this.mainPrice);
        if (mainTitle) mainTitle.textContent = variant.title || '';
        this.syncSheetSize(mainSize);
        this.update();
      }

      getMainSize(variant) {
        if (Array.isArray(variant.options) && variant.options[0]) return String(variant.options[0]);
        if (variant.option1) return String(variant.option1);
        return String(variant.title || '').split(' / ')[0];
      }

      normaliseSize(value) {
        return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
      }

      syncSheetSize(mainSize) {
        const sheetSelect = this.querySelector('[data-bundle-sheet-variant]');
        const sheetRow = sheetSelect?.closest('[data-bundle-item="sheet"]');
        const sheetToggle = sheetRow?.querySelector('[data-bundle-toggle]');
        const sheetStatus = sheetRow?.querySelector('[data-bundle-size-status]');
        if (!sheetSelect || !sheetRow || !sheetToggle) return;

        const normalisedMainSize = this.normaliseSize(mainSize);
        const matchingOption = Array.from(sheetSelect.options).find((option) => {
          return this.normaliseSize(option.dataset.size || option.textContent) === normalisedMainSize;
        });

        if (matchingOption) {
          sheetSelect.value = matchingOption.value;
          sheetSelect.disabled = false;
          sheetToggle.disabled = false;
          sheetToggle.checked = true;
          if (sheetStatus) {
            sheetStatus.textContent = sheetStatus.dataset.availableText || '';
            sheetStatus.classList.remove('is-unavailable');
          }
          return;
        }

        sheetSelect.disabled = true;
        sheetToggle.checked = false;
        sheetToggle.disabled = true;
        if (sheetStatus) {
          sheetStatus.textContent = this.dataset.sheetUnavailableText || '';
          sheetStatus.classList.add('is-unavailable');
        }
      }

      getSelectedItems() {
        const items = [{ id: this.mainVariantId, quantity: 1, price: this.mainPrice }];
        this.querySelectorAll('[data-bundle-item]:not([data-bundle-item="main"])').forEach((row) => {
          const toggle = row.querySelector('[data-bundle-toggle]');
          const select = row.querySelector('[data-bundle-variant]');
          const option = select?.selectedOptions?.[0];
          if (toggle?.checked && select?.value && option) {
            items.push({
              id: select.value,
              quantity: 1,
              price: Number(option.dataset.price || 0)
            });
          }
        });
        return items;
      }

      update() {
        this.querySelectorAll('[data-bundle-variant]').forEach((select) => {
          const option = select.selectedOptions?.[0];
          const price = select.closest('[data-bundle-item]')?.querySelector('[data-item-price]');
          if (price && option) price.textContent = this.formatMoney(Number(option.dataset.price || 0));
        });

        const items = this.getSelectedItems();
        const count = items.length;
        const subtotal = items.reduce((sum, item) => sum + item.price, 0);
        const unlocked = count === 3;
        const total = unlocked
          ? Math.round(subtotal * (100 - this.discountPercent) / 100)
          : subtotal;
        const saving = subtotal - total;

        this.querySelector('[data-bundle-progress-fill]').style.width = `${Math.min(100, count / 3 * 100)}%`;
        this.querySelector('[data-bundle-progress-text]').textContent = this.progressTemplate.replace('__COUNT__', String(count));
        this.querySelector('[data-bundle-unlocked]').hidden = !unlocked;
        this.querySelector('[data-bundle-subtotal]').textContent = this.formatMoney(subtotal);
        this.querySelector('[data-bundle-total]').textContent = this.formatMoney(total);
        this.querySelector('[data-bundle-saving]').textContent = this.formatMoney(saving);
        this.button.disabled = !unlocked || !this.mainVariantId;
      }

      async addToCart() {
        const items = this.getSelectedItems();
        if (items.length !== 3) return;
        const defaultText = this.dataset.buttonText;
        this.button.disabled = true;
        this.button.textContent = this.dataset.loadingText;
        this.status.textContent = '';
        this.status.className = 'product-bundle__status';

        try {
          const response = await fetch(`${this.dataset.rootUrl}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: items.map(({ id, quantity }) => ({ id, quantity }))
            })
          });

          if (!response.ok) throw new Error('Bundle add failed');
          this.status.textContent = this.dataset.successText;
          this.status.classList.add('is-success');

          if (document.querySelector('cart-drawer')) {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
          } else {
            window.location.assign(`${this.dataset.rootUrl}cart`);
          }
        } catch (error) {
          this.status.textContent = this.dataset.errorText;
          this.status.classList.add('is-error');
        } finally {
          this.button.textContent = defaultText;
          this.update();
        }
      }

      formatMoney(cents) {
        const currency = window.Shopify?.currency?.active || 'GBP';
        const locale = document.documentElement.lang || 'en-GB';
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency
        }).format(cents / 100);
      }
    }

    customElements.define('product-bundle-builder', ProductBundleBuilder);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-towel-reward-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('towel-reward-builder')) {
    class TowelRewardBuilder extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;
        this.discountFive = Number(this.dataset.discountFive || 5);
        this.discountTen = Number(this.dataset.discountTen || 10);
        this.button = this.querySelector('[data-reward-submit]');
        this.status = this.querySelector('[data-reward-status]');
        this.clickHandler = (event) => this.handleClick(event);
        this.addEventListener('click', this.clickHandler);
        this.button.addEventListener('click', () => this.addToCart());
        this.update();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.clickHandler);
      }

      handleClick(event) {
        const row = event.target.closest('[data-towel-row]');
        if (!row) return;
        const output = row.querySelector('[data-quantity]');
        let quantity = Number(output.textContent || 0);
        if (event.target.closest('[data-quantity-minus]')) quantity = Math.max(0, quantity - 1);
        if (event.target.closest('[data-quantity-plus]')) quantity = Math.min(20, quantity + 1);
        output.textContent = String(quantity);
        this.update();
      }

      getRows() {
        return Array.from(this.querySelectorAll('[data-towel-row]')).map((row) => ({
          row,
          key: row.dataset.sizeKey,
          id: row.dataset.variantId,
          price: Number(row.dataset.price || 0),
          quantity: Number(row.querySelector('[data-quantity]')?.textContent || 0)
        }));
      }

      getReward(rows) {
        const qualified = rows.filter((item) => item.quantity >= 2);
        if (qualified.length === 3) return { percent: this.discountTen, qualified };
        if (qualified.length >= 2) return { percent: this.discountFive, qualified };
        return { percent: 0, qualified };
      }

      update() {
        const rows = this.getRows();
        const reward = this.getReward(rows);
        const subtotal = rows.reduce((sum, item) => sum + item.price * item.quantity, 0);
        const saving = rows.reduce((sum, item) => {
          return sum + Math.round(item.price * item.quantity * reward.percent / 100);
        }, 0);
        const total = subtotal - saving;

        rows.forEach((item) => item.row.classList.toggle('is-qualified', item.quantity >= 2));
        this.querySelector('[data-reward-progress]').style.width = `${reward.qualified.length / 3 * 100}%`;
        this.querySelector('[data-reward-subtotal]').textContent = this.formatMoney(subtotal);
        this.querySelector('[data-reward-saving]').textContent = this.formatMoney(saving);
        this.querySelector('[data-reward-total]').textContent = this.formatMoney(total);

        const heading = this.querySelector('[data-reward-heading]');
        const nudge = this.querySelector('[data-reward-nudge]');
        if (reward.percent === this.discountTen) {
          heading.textContent = `${this.discountTen}% reward unlocked`;
          nudge.textContent = 'All three towel sizes qualify. Extra towels receive the same reward.';
        } else if (reward.percent === this.discountFive) {
          const missing = rows.find((item) => item.quantity < 2);
          const needed = Math.max(0, 2 - (missing?.quantity || 0));
          const label = missing?.key === 'hand' ? 'hand towel' : missing?.key === 'bath' ? 'bath towel' : 'bath sheet';
          heading.textContent = `${this.discountFive}% reward unlocked`;
          nudge.textContent = `Add ${needed} more ${label}${needed === 1 ? '' : 's'} to unlock ${this.discountTen}%.`;
        } else {
          heading.textContent = 'Build your towel set';
          if (reward.qualified.length === 1) {
            nudge.textContent = `Choose at least 2 from one more towel size to unlock ${this.discountFive}%.`;
          } else {
            nudge.textContent = `Choose at least 2 towels from any 2 sizes to unlock ${this.discountFive}%.`;
          }
        }

        this.button.disabled = reward.percent === 0 || subtotal === 0;
      }

      async addToCart() {
        const rows = this.getRows();
        const reward = this.getReward(rows);
        if (reward.percent === 0) return;
        const cartDrawer = document.querySelector('cart-drawer');
        let sections = 'cart-icon-bubble';
        if (cartDrawer) {
          sections += `,${cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
        }
        const items = rows
          .filter((item) => item.quantity > 0)
          .map((item) => ({
            id: item.id,
            quantity: item.quantity,
            properties: {
              '_Towel reward': `${reward.percent}%`,
              '_Towel set': 'Flexible set builder'
            }
          }));
        const defaultText = this.dataset.buttonText;
        this.button.disabled = true;
        this.button.textContent = this.dataset.loadingText;
        this.status.textContent = '';
        this.status.className = 'towel-reward__status';

        try {
          const response = await fetch(`${this.dataset.rootUrl}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items,
              sections,
              sections_url: window.location.pathname
            })
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || 'Towel set add failed');
          this.status.textContent = this.dataset.successText;
          this.status.classList.add('is-success');
          if (window.theme?.settings?.afterAtc === 'page') {
            setTimeout(() => window.location.assign(`${this.dataset.rootUrl}cart`), 300);
          } else {
            const cartIconBubble = document.getElementById('cart-icon-bubble');
            if (cartIconBubble && data.sections?.['cart-icon-bubble']) {
              cartIconBubble.innerHTML = data.sections['cart-icon-bubble'];
            }

            if (cartDrawer && data.sections) {
              setTimeout(() => {
                cartDrawer.renderContents(data, window.theme?.settings?.afterAtc === 'drawer');
              }, 300);
            } else if (window.location.pathname !== `${this.dataset.rootUrl}cart`) {
              window.location.assign(`${this.dataset.rootUrl}cart`);
            }
          }
        } catch (error) {
          this.status.textContent = this.dataset.errorText;
          this.status.classList.add('is-error');
        } finally {
          this.button.textContent = defaultText;
          this.update();
        }
      }

      formatMoney(cents) {
        const currency = window.Shopify?.currency?.active || 'GBP';
        const locale = document.documentElement.lang || 'en-GB';
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
      }
    }

    customElements.define('towel-reward-builder', TowelRewardBuilder);
  }
  } catch(e) { console.error(e); }
})();

})();
